<!-- 布局 -->
<template>
  <div>
    <div class="content">
      <div class="aboutUs-mid clearfix">
        <!-- <el-carousel :interval="6000" height="710px" arrow="always">
          <el-carousel-item v-for="item in 2" :key="item">
            <div class="box">
              <div class="left">
                <img src="../assets/images/people.jpg" alt />
              </div>
              <div class="right">
                <div class="right_title">新力资助之道</div>
                <p>帮组每一个努力的人</p>
                <p>新力公益基金会的资助是有态度的，</p>
                <p>我们更倾向于那些虽然经历了生活的磨难，</p>
                <p>但依旧砥砺前行者。</p>
                <div class="right_content_title">人物故事</div>
                <div
                  class="right_content_detail"
                >隆平尽管没有从老师的回答中得到满意的答案，但却使他对这些抽象难懂的概念产生了兴趣，增强了逻辑思维能力。这些留在心中的疑惑，实际上是袁隆平思维发展和心灵成长的标志。他开始对抽象的概念发生兴趣，开动脑筋进行思索，强烈的求知欲，使他学到了不少书本上学不到的东西。</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>-->
        <swiper :options="swiperOption">
          <swiper-slide>
            <div class="box">
              <div class="left box-1-leftw">
                <img src="../assets/images/people.jpg" alt />
              </div>
              <div class="right box-1-rightw">
                <div class="right_title tit">新力资助之道</div>
                <p>帮助每一个努力生活的人</p>
                <p>&nbsp;</p>
                <p>新力公益基金会的资助是有态度的，</p>
                <p>我们更倾向于资助那些虽然经历了生活的磨难，</p>
                <p>但依旧砥砺前行者。</p>
                <div class="right_content_title">扶贫基地</div>
                <div class="right_content_detail">
                  <!-- <p>项目简介</p>
                  <p>
                    通过建立农村合作社，对农户进行培训，并就当地特色农产品在生产技术、粗加工、生产销售等进行全方位的支持，打造爆款农产品，提升农户收入。现项目已经在赣州市石城县建立500亩白莲基地。
                  </p> -->
                  <p>&nbsp;</p>
                </div>
                <div class="right_content_detail">
                  <p>白莲产业帮扶基地</p>
                  <p>
                    已组建完成莲子种植合作社的成立及硬件和软件的投入，制定和优化白莲生产技术标准1套，联合共建标准化白莲生产示范基地500亩、合作社辐射带动面积1829.7亩，将带动农户1183户、4884人，其中建档立卡贫困户184户、647人，社员132户，示范户71户，建档立卡贫困户30户。
                  </p>
                  <p>&nbsp;</p>
                </div>
                <div class="right_content_detail">
                  <p>项目亮点</p>
                  <p>
                    整合企业资源，助力扶贫事业。通过与新力集团旗下的“有家便利店”合作，打造“燕麦莲子粥”，在全国近500家便利店销售，助力农户脱贫。
                  </p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="box box-02">
              <div class="left">
                <div class="tit">新力项目板块</div>
                <p>我们的项目领域涉及：</p>
                <p>紧急救灾，儿童福利，边缘救助，行业促进。</p>
                <div class="b-desc">
                  <p>我们的项目主要以江西省为主，覆盖广东、四川、长三角地区</p>
                  <p>2019年</p>
                  <p>
                    我们在7个城市落地
                    <span>16</span>个公益项目，<span>125</span>个子项目
                  </p>
                  <p>
                    受益人数
                    <span>272468</span>
                  </p>
                  <p>
                    受益人次
                    <span>923047</span>
                  </p>
                </div>
              </div>
              <div class="right">
                <img src="../assets/images/aboutus-img3.png" alt />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="box">
              <div class="pd90 partner-box">
                <div class="left box-2-leftw">
                  <img src="../assets/images/aboutus-img-4.jpg" alt style="width:640px" />
                </div>
                <div class="right box-3-rightw" style="margin-top:0;">
                  <div class="right_title tit">新力伙伴认知</div>
                  <p>我们尊重合作伙伴，作为资助类基金会，</p>
                  <p>我们始终与合作伙伴共同参与项目生命周期管理，</p>
                  <p>共创社会影响力。</p>
                  <div style="margin-top: 20px;">
                    <ul class="partner-list">
                      <li>上海市民政局</li>
                      <li>江西省民政厅</li>
                      <li>江西省扶贫办</li>
                      <li>江西省文明办</li>
                      <li>共青团江西省委</li>
                      <li>中国扶贫基金会</li>
                      <li>Save the Children</li>
                      <li>壹基金</li>
                      <li>清华大学</li>
                      <li>上海交通大学</li>
                      <!-- <li>人民日报社</li>
                        <li>南方周末</li>
                        <li>青年报</li>
                        <li>江西日报</li>
                        <li>梨视频</li> -->
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="box">
              <div class="left box-3-leftw">
                <div class="right_title tit">新力资源撬动</div>
                <p>作为一家企业基金会，</p>
                <p>撬动企业"专长"助力公益事业是我们一直思考的问题。</p>

                <div class="right_content_detail mt50">
                  <p>“ 惠民空间·惠州市老旧社区改造项目”是惠州市解决老旧社区群众生活难题，完善社区治理、改善人居环境而推出的惠民利民项目。</p>
                </div>

                <div class="right_content_detail mt30">
                  <p>新力公益基金会撬动新力地产的工程、成本、设计三大部门资源助力“ 惠民空间·惠州市老旧社区改造项目”。两个月后，惠州市麦迪新村社区3500平方米的老旧活动场地焕然一新。</p>
                </div>
                <div class="right_content_detail mt30">
                  <p>其中 ,与惠州市慈善总会联合举办的“ 惠民空间·惠州市老旧社区改造项目”主题慈善晚宴
                    ,新力公益基金会现场捐赠200万元。当晚共募集善款1000余万元,款项全数用于“惠民空间·惠州市老旧社区改造项目”。</p>
                </div>
              </div>
              <div class="right box-4-rightw box4img">
                <img src="../assets/images/aboutus-img5.jpg" alt style="width:100%" />
                <img src="../assets/images/aboutus-img6.jpg" alt style="width:100%" />
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        swiperOption: {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        }
      };
    },
    mounted() {
      let doc = document.getElementsByClassName("box")[0];
    },
    methods: {
      pre() {
        console.log("doc", doc);
      },
      next() {}
    }
  };

</script>
<style lang="scss" scoped>
  .content {
    width: 100%;
    height: 710px;
    padding-top: 65px;

    .aboutUs-mid {
      width: 1320px;
      margin: 0 auto;
    }

    .tit {
      font-size: 28px;
      margin-bottom: 30px;
    }

    .b-desc {
      margin-top: 60px;
      color: #a6a5a5;

      span {
        color: #a1cf67;
        font-size: 22px;
      }
    }

    .pd90 {
      padding-top: 90px;
    }

    .mt100 {
      margin-top: 100px;
    }

    .mt50 {
      margin-top: 50px;
    }

    .mt30 {
      margin-top: 30px;
    }

    .box-1-leftw {
      width: 430px;
    }

    .partner-list {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 50%;
        color: #333;
      }
    }

    .box-1-rightw {
      width: 720px;
    }

    .box-4-leftw {
      width: 600px;
    }

    .box-3-leftw {
      width: 640px;
      padding-top: 100px;
    }

    .box-4-rightw {
      width: 500px;
    }

    p {
      color: #333;
      line-height: 23px;
      letter-spacing: 2px;
    }

    .box4img {
      img {
        margin-bottom: 40px;
      }
    }

    .box {
      position: relative;
      width: 1200px;
      height: 710px;
      padding: 0 70px;

      .partner-box {
        display: flex;

      }

      .left {
        float: left;
        flex-shrink: 0;

        p {
          line-height: 23px;
        }
      }



      .right {
        float: left;
        margin-top: 60px;
        margin-left: 35px;

        img {
          width: 533px;
        }

        .right_title {}

        .right_content_title {
          font-size: 24px;
          margin-top: 20px;
          margin-bottom: 35px;
        }

        .right_content_detail {
          line-height: 32px;
          color: #a6a5a5;
        }
      }

      .pre {
        position: absolute;
        width: 50px;
        height: 50px;
        background: url("../assets/images/xy.jpg") no-repeat;
        left: -66px;
        top: 262px;
      }

      .next {
        position: absolute;
        width: 50px;
        height: 50px;
        background: url("../assets/images/dy.jpg") no-repeat;
        right: -66px;
        top: 262px;
      }
    }

    .box-02 {
      .left {
        width: 310px;
      }

      .right {
        width: 850px;
        height: auto;
        margin-top: 0;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    .swiper-button-next {
      background-image: url("../assets/images/dy.jpg");
      width: 50px;
      height: 50px;
      background-size: 80%;
    }

    .swiper-button-prev {
      background-image: url("../assets/images/xy.jpg");
      width: 50px;
      height: 50px;
      background-size: 80%;
    }
  }

  .partner-list {
    //  margin-top: 70px;
  }

  .partner-list li {
    float: left;
    min-width: 20%;
    margin-top: 10px;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/TabNew.vue